// extracted by mini-css-extract-plugin
export var dividerLine = "_9y-3";
export var itemImage = "_9y-9";
export var lightDivider = "_9y-4";
export var modalContent = "_9y-5";
export var modalContentCompact = "_9y-6";
export var productCard = "_9y-a";
export var productImage = "_9y-b";
export var productImageCompact = "_9y-7";
export var productImagePlaceholder = "_9y-c";
export var productImagePlaceholderCompact = "_9y-8";
export var progressBarBackground = "_9y-1";
export var progressBarContainer = "_9y-0";
export var progressBarFill = "_9y-2";